import cx from 'classnames';
import type { ReactElement, ReactNode } from 'react';
import MarkerLarge from './markers/marker-large.inline.svg';
import MarkerDefault from './markers/marker.inline.svg';
import PositionMarker from './markers/position-marker.inline.svg';
import styles from './styles.module.css';

type MarkerType = 'position';
type MarkerSize = 'default' | 'small' | 'large';

interface MarkerSizeValues {
  width: number;
  height: number;
}

export const getMarkerSizeValues = (size?: MarkerSize): MarkerSizeValues => {
  if (size === 'large') return { width: 54, height: 56 };
  return { width: 40, height: 40 };
};

const getMarker = (type?: MarkerType, size?: MarkerSize): ReactElement => {
  // size prop has no incidence on position marker;
  if (type === 'position') return <PositionMarker color="#08d48e" />;
  switch (size) {
    case 'large':
      return <MarkerLarge color="#624af7" />;
    default:
      return <MarkerDefault color="#624af7" />;
  }
};

export interface MarkerProps {
  type?: MarkerType;
  size?: MarkerSize;
}

export function Marker({ type, size }: MarkerProps): ReactNode {
  return (
    <div
      className={cx({
        [styles.PositionMarker]: type === 'position',
        [styles.DefaultMarker]: type !== 'position',
        [styles.LargeMarker]: size && size === 'large',
      })}
    >
      {getMarker(type, size)}
    </div>
  );
}
